<script lang="ts" setup>
import { ChecklistCriteria, CriteriaInstance } from "types/Checklist";
import { EvaluationRelevantInstance } from "types/EvaluationResults";

const props = defineProps({
  criteriaInstance: {
    type: Object as PropType<CriteriaInstance>,
    required: true,
  },
  checklistCriteria: {
    type: Object as PropType<ChecklistCriteria>,
    required: true,
  },
});

const emits = defineEmits(["reportProblem"]);

const onReportProblem = (ev: any, isControl: boolean) => {
  emits("reportProblem", ev, isControl);
};

const documentId = inject("documentId") as any;
const evaluationResultsStore = useStepResultsStore(documentId);

const {
  criteriaParagraphPositionsData,
  relevantInstancesForParagraph,
  allocatedRelevantInstances,
  criteriaConfig,
} = storeToRefs(evaluationResultsStore);

const onUpdateParagraph = (value: number, index: number) => {
  try {
    evaluationResultsStore.updateManualParagraphPoints(index, value);
  } catch (error) {}
};

const { addPositions } = useDocumentHighlightStore(documentId);

const documentTokenIdPositionMap =
  useDocumentTokenIdPositionMapStore(documentId);
const { tokenGlobalPositionFromId } = storeToRefs(documentTokenIdPositionMap);

const onFocus = (ev: any) => {
  ev.target.select();
};
</script>

<template>
  <div class="border rounded p-4 h-full overflow-auto">
    <DocumentPanelChecklistParagraphScore
      v-for="(paragraphPositionData, key) in criteriaParagraphPositionsData"
      :checklist-criteria="checklistCriteria"
      :criteria-instance="criteriaInstance"
      :paragraph-position-data="paragraphPositionData"
      :key="key"
      :data-step-id="`paragraph-instance-container-${key}`"
      @report-problem="onReportProblem"
    />
  </div>
</template>

<style scoped></style>
